import type { LocalRecord } from '@dovefiniscono/sync';
import { addDays } from '../lib/dates';

export type Task = LocalRecord<'tasks'>;
export type TaskList = LocalRecord<'taskLists'>;

export type TaskView =
  | { kind: 'all' }
  | { kind: 'inbox' }
  | { kind: 'today' }
  | { kind: 'week' }
  | { kind: 'list'; listId: string };

export const PRIORITY_LABELS = ['', 'bassa', 'media', 'alta'] as const;
export const PRIORITY_OPTIONS = ['Nessuna', 'Bassa', 'Media', 'Alta'] as const;

export const isOpen = (task: Task) => task.completedAt === null;
export const isOverdue = (task: Task, today: string) =>
  isOpen(task) && task.dueDate !== null && task.dueDate < today;

export function matchesView(task: Task, view: TaskView, today: string): boolean {
  switch (view.kind) {
    case 'all':
      return true;
    case 'inbox':
      return task.listId === null;
    case 'today':
      return task.dueDate !== null && task.dueDate <= today;
    case 'week':
      return task.dueDate !== null && task.dueDate <= addDays(today, 7);
    case 'list':
      return task.listId === view.listId;
  }
}

/** Open tasks: the ones with a date first (earliest first), then by priority, then by order. */
export function compareOpen(a: Task, b: Task): number {
  if (a.dueDate !== b.dueDate) {
    if (a.dueDate === null) return 1;
    if (b.dueDate === null) return -1;
    return a.dueDate < b.dueDate ? -1 : 1;
  }
  if (a.priority !== b.priority) return b.priority - a.priority;
  return a.position - b.position;
}

/** Completed tasks: most recently completed first. */
export function compareDone(a: Task, b: Task): number {
  return (b.completedAt ?? '').localeCompare(a.completedAt ?? '');
}
